export const AdvantagesStylesTitle =
  'headline-h6 text-20 font-Roboto tracking-0 leading-28 mb-[35px] inline-flex w-full items-end whitespace-nowrap text-left text-white'
export const AdvantagesStylesList = 'flex flex-col lg:mt-0'
export const AdvantagesStylesListItem =
  'my-1.5 mt-0 flex md:flex-none md:whitespace-nowrap'
export const AdvantagesStyleText =
  'font-Roboto text-16 leading-24 ml-[16px] inline font-light tracking-0 text-white'
